module.exports = __webpack_public_path__ + "static/media/how-we-hire-new.0df8f014.webp";